import { useCategorySearch } from '@shopware/composables'
import type { Schemas } from '#shopware'

export function useSubCategories() {
  const { advancedSearch } = useCategorySearch()

  const subCategoriesFlat = ref<Schemas['Category'][]>([])

  const subCategoriesLoading = ref(true)

  async function fetchSubCategories(parentId: MaybeRef<string>) {
    try {
      const result = await advancedSearch({
        query: {
          filter: [
            {
              type: 'equals',
              field: 'parentId',
              value: toValue(parentId),
            },
            {
              type: 'multi',
              operator: 'AND',
              queries: [
                {
                  type: 'equals',
                  field: 'active',
                  value: true,
                },
              ],
            },
          ],
          includes: {
            category: [
              'id',
              'name',
              'translated',
              'parentId',
              'parent',
              'breadcrumb',
              'level',
              'childCount',
            ],
          },
          associations: {
            seoUrls: {},
          },
        },

      })

      subCategoriesFlat.value = result
      subCategoriesLoading.value = false
    } catch (error) {
      console.error('Error fetching sub-categories:', error)
      subCategoriesLoading.value = false
    }
  }

  return {
    subCategoriesLoading,
    subCategoriesFlat,
    fetchSubCategories,
  }
}
